import type { MobileSection, WebSectionLeft, WebSectionRight } from "./types";

export const SECTION = {
  ACCOUNTS: "accounts",
  RECENT_TRANSACTIONS: "recent_transactions",
  PAYMENT_ACTIVITY_ACH: "payment_activity_ach",
  BIOMETRICS: "biometrics",
  SUBSCRIPTIONS: "subscriptions",
  VERIFY_EXTERNAL_ACCOUNTS: "verify_external_accounts",
  /** New experience for balances and verification */
  EXTERNAL_ACCOUNTS: "external_accounts",
  /** Renders SavvyMoney or Array+ */
  CREDIT_MONITORING: "credit_monitoring",
  MARKETING_BANNER_IMAGE: "marketing_banner_image",
  MARKETING_CARD: "marketing_card",
  MARKETING_CARD_IMAGE: "marketing_card_image",
  SERVICES: "services",
  CARD_OFFERS: "card_offers",
  ACCOUNT_TOTALS: "account_totals",
  /** Renders MX widget, titled "Spending" */
  CHART_CARD: "chart_card",
} as const;

export const MOBILE_HOME_SECTIONS: MobileSection[] = [
  SECTION.MARKETING_BANNER_IMAGE,
  SECTION.ACCOUNTS,
  SECTION.EXTERNAL_ACCOUNTS,
  SECTION.RECENT_TRANSACTIONS,
  SECTION.PAYMENT_ACTIVITY_ACH,
  SECTION.VERIFY_EXTERNAL_ACCOUNTS,
  SECTION.SUBSCRIPTIONS,
  SECTION.BIOMETRICS,
  SECTION.CREDIT_MONITORING,
  SECTION.MARKETING_CARD,
  SECTION.SERVICES,
  SECTION.CARD_OFFERS,
];

export const WEB_DASHBOARD_SECTIONS_LEFT: WebSectionLeft[] = [
  SECTION.MARKETING_BANNER_IMAGE,
  SECTION.ACCOUNTS,
  SECTION.EXTERNAL_ACCOUNTS,
  SECTION.RECENT_TRANSACTIONS,
  SECTION.CARD_OFFERS,
];

export const WEB_DASHBOARD_SECTIONS_RIGHT: WebSectionRight[] = [
  SECTION.ACCOUNT_TOTALS,
  SECTION.CHART_CARD,
  SECTION.CREDIT_MONITORING,
  SECTION.VERIFY_EXTERNAL_ACCOUNTS,
  SECTION.MARKETING_CARD,
  SECTION.SERVICES,
  SECTION.SUBSCRIPTIONS,
  SECTION.MARKETING_CARD_IMAGE,
];
